import React, { useState, useEffect } from 'react';
import * as Utils from '../../common/utils';
import * as REQUEST from "../../common/request";
import './index.less';

import aDefault from './images/a.png';
import aSelected from './images/a1.png';
import bDefault from './images/b.png';
import bSelected from './images/b1.png';
import cDefault from './images/c.png';
import cSelected from './images/c1.png';
import dDefault from './images/d.png';
import dSelected from './images/d1.png';
import eDefault from './images/e.png';
import eSelected from './images/e1.png';

const PageModel = props => {
    // 定义图片数组
    const images = [
        { id: 1, defaultSrc: aDefault, selectedSrc: aSelected },
        { id: 2, defaultSrc: bDefault, selectedSrc: bSelected },
        { id: 3, defaultSrc: cDefault, selectedSrc: cSelected },
        { id: 4, defaultSrc: dDefault, selectedSrc: dSelected },
        { id: 5, defaultSrc: eDefault, selectedSrc: eSelected }
    ];
    // 状态管理选中的ID
    const [selectedId, setSelectedId] = useState(1);
    const [url, setUrl] = useState('');

    const [list, setList] = useState([]);
    const getList = async (selectedId) => {
        const result = await REQUEST.get({
            url: '/zhujiajiao/v2/guider/list',
            data: { type: selectedId }
        });
        if (!result) return;

        result.data.map(item => {
            item.key = item.id;
            return item;
        });
        setList(result.data);
    };
    const getBanner = async () => {
        const result = await REQUEST.get({
            url: '/zhujiajiao/v2/file/get',
            data: { id: 1 }
        });
        if (!result) return;
        setUrl(result.data.link);

        // result.data.map(item => {
        //     item.key = item.id;
        //     return item;
        // });

    };

    useEffect(() => {
        getList(selectedId);
        getBanner();//获取导游页面的首页banner价格显示图
        Utils.setPageTitle('导游服务');
        return () => false;
    }, [123]);

    // 处理点击事件
    const handleSelect = (id) => {
        setSelectedId(id == selectedId ? null : id); // 如果点击已选中的，则取消选择
        if (id != selectedId) {
            getList(id);
        }
    };


    return (
        <section className="h5guider-container" style={{ minHeight: window.innerHeight }}>
            <div className='h5guider-title'>朱家角古镇旅游区收费标准</div>
            <div className='h5guider-subtitle'><img src={'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/' + url} alt="" /></div>
            <div className='h5guider-price'>注：超过5小时按2批次收费。</div>
            <div className='h5guider-title'>朱家角古镇旅游区导游信息</div>
            <div className='h5guider-button'>
                {images.length > 0 && images.map((image, index) => (
                    <div
                        key={index}
                        className={`h5guider-button-item ${selectedId == image.id ? 'selected' : ''}`}
                        onClick={() => handleSelect(image.id)}
                    >
                        <img src={selectedId === image.id ? image.selectedSrc : image.defaultSrc} alt="" />
                    </div>
                ))}
            </div>

            <div className='h5guider-icon'>
                <div className='h5guider-icon-list'>
                    {
                        list.length > 0 && list.map((item, index) => {
                            return (
                                <div className='h5guider-icon-item' key={index}>
                                    <div className='h5guider-icon-item-img'>
                                        <img src={'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/' + item.link} alt="" />
                                    </div>
                                    <div className='h5guider-icon-item-title'>{item.name} <div>{item.english}</div></div>
                                    {/* <div className='h5guider-icon-item-ping'>评价<span>★★★★★</span></div> */}
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            {
                selectedId == 1 &&
                <div>
                    <div className='h5guider-price footer'>高级导游和语种导游需提前2天预约</div>
                    <div className='h5guider-price'>预约电话：021-59280227</div>
                </div>
            }
            {
                selectedId == 2 &&
                <div>
                    <div className='h5guider-price footer'>Advanced guides and language guides require a reservation two days in advance.</div>
                    <div className='h5guider-price'>Reservation phone number: 021-59280227.</div>
                </div>
            }
            {
                selectedId == 3 &&
                <div>
                    <div className='h5guider-price footer'>高級ガイドと語学ガイドは、2日前に予約が必要です。</div>
                    <div className='h5guider-price'>予約電話番号：021-59280227。</div>
                </div>
            }
            {
                selectedId == 4 &&
                <div>
                    <div className='h5guider-price footer'>Für hochwertige und Sprachführer ist eine Reservierung zwei Tage im Voraus erforderlich.</div>
                    <div className='h5guider-price'>Reservierungsnummer: 021-59280227.</div>
                </div>
            }
            {
                selectedId == 5 &&
                <div>
                    <div className='h5guider-price footer'>고급 가이드와 언어 가이드는 2일 전에 예약해야 합니다.  </div>
                        <div className='h5guider-price'>예약 전화: 021-59280227.</div>
                </div>
            }
            <div className='h5guider-bottom-img'>
                <img src={require('./images/bottom.png')} alt="" />
            </div>
        </section>
    );
};

export default PageModel;
